import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { translate } from 'react-switch-lang';
import { Button, FormGroup, Modal, ModalBody, ModalHeader } from 'reactstrap';
import SweetAlert from 'sweetalert2';

const CreateDevise = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const { register, handleSubmit } = useForm();

  const onSubmit = async ({ name, code }) => {
    const currency = { name, code: code.toUpperCase() };

    const codeExist = props.devises.find((devise) => devise.code.toUpperCase() === code.toUpperCase());

    if (codeExist) {
      return SweetAlert.fire(props.t('error'), props.t('code_exist'), 'error');
    }

    const resposne = await props.createDevise(currency);

    const curr = {
      id: resposne.data,
      name,
      code: code.toUpperCase(),
    };

    props.setDeviseState((prevState) => [...prevState, curr]);

    setIsOpen(false);
  };

  return (
    <>
      <Button onClick={() => setIsOpen(true)} outline color="success">
        {props.t('create_devise')}
      </Button>

      <Modal isOpen={isOpen} toggle={() => setIsOpen(false)} centered>
        <ModalHeader>{props.t('detail_unit')}</ModalHeader>

        <ModalBody>
          <form onSubmit={handleSubmit(onSubmit)} className="needs-validation">
            <FormGroup className="form-row">
              <label>{props.t('devise_name')}</label>
              <input type="text" className="form-control" {...register('name', { required: true })} />
            </FormGroup>
            <FormGroup className="form-row">
              <label>{props.t('devise_code')}</label>
              <input
                style={{ textTransform: 'uppercase' }}
                type="text"
                className="form-control"
                maxLength={3}
                {...register('code', { required: true, maxLength: 3 })}
              />
            </FormGroup>

            <Button outline color="success" className="float-right" type="submit">
              {props.t('save')}
            </Button>
            <Button
              style={{ marginRight: '10px' }}
              color="secondary"
              className="float-right"
              onClick={() => setIsOpen(false)}
            >
              {props.t('Cancel')}
            </Button>
          </form>
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(CreateDevise);
